import { render, staticRenderFns } from "./LKPublicationsFormdataRevisionsListModal.vue?vue&type=template&id=17e08526&"
import script from "./LKPublicationsFormdataRevisionsListModal.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataRevisionsListModal.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataRevisionsListModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports